// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2sOH_","overlayModal":"style__overlayModal___3kcyk","overlayModalInner":"style__overlayModalInner___2YXlt","overlayCloseButton":"style__overlayCloseButton___1OW8B","overlayModalTitle":"style__overlayModalTitle___3c2Fs","overlayModalText":"style__overlayModalText___3fHKC","overlayModalTextBold":"style__overlayModalTextBold___3qa3n","overlayModalButtons":"style__overlayModalButtons___2sdbF","overlayModalButtonsItem":"style__overlayModalButtonsItem___8L0J2","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___ZSD8L","buttonActive":"style__buttonActive___213hV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-password/style.css
// module id = 1180
// module chunks = 0